var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckDone20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.75 5L7.75 13L4.25 9.5C3.75 9 3 9 2.5 9.5C2 10 2 10.75 2.5 11.25L6.875 15.625C7.125 15.875 7.375 16 7.75 16C8.125 16 8.375 15.875 8.625 15.625L17.5 6.75C18 6.25 18 5.5 17.5 5C17 4.5 16.25 4.5 15.75 5Z",
  fill: "currentColor"
})));
export { SvgCheckDone20 as ReactComponent };